import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import SubscriptionDetailsPanel from "./SubscriptionDetails";
import ClientPaymentMethodPanel from "./ClientPaymentMethodPanel";
import SubscriptionPricingPanel from "./SubscriptionPricingPanel";
import BillingDetailsPanel from "./BillingDetails/BillingDetailsPanel";
import UserActionPanel from "systemsettings/menu/UserActionPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { routes } from "utilities/routing/generatedRoutes";
import moment from "moment";
import { Stripe } from "@stripe/stripe-js";
import { useLoaderData } from "react-router";
import { CreditBalancePanel } from "credits/CreditBalancePanelApp";
//import { formatLongDate } from "utilities";

export interface SubscriptionDetailLoaderData {
  viewModel: server.viewmodel.SubscriptionDetailFrontModel
  stripePromise: Promise<Stripe>
}

const SubscriptionDetailPage = () => {
  const { viewModel, stripePromise } = useLoaderData<SubscriptionDetailLoaderData>();
  // let newPricingAppliesFrom = moment.utc("2025-05-01");

  // let nextSubscriptionPricingTitle = RESX.Subscription.PricingAfterX.replace("{0}", formatLongDate(newPricingAppliesFrom));

  // const isNextSubscriptionAfter1May2025 = moment.utc(viewModel.activeSubscription.end).isAfter(newPricingAppliesFrom);

  // if (isNextSubscriptionAfter1May2025) {
  //   nextSubscriptionPricingTitle = `${RESX.Subscription.Renewal} ${formatLongDate(viewModel.activeSubscription.end)}`;
  //   newPricingAppliesFrom = moment.utc(viewModel.activeSubscription.end);
  // }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <SubscriptionDetailsPanel {...viewModel} />
          {site.currentEnvironment.betaFeaturesEnabled && <CreditBalancePanel panelType="s1_related-feature-panel" />}
          <ClientPaymentMethodPanel
            stripe={stripePromise}
            config={viewModel.paymentSetup.config}
            currentPaymentMethod={viewModel.paymentSetup.currentPaymentMethod}
          />

          {viewModel.activeSubscription.type === "paid" && <>
            <SubscriptionPricingPanel
              discountPercentage={viewModel.discountPercentage}
              discountUntil={viewModel.discountUntil}
              internalUsers={viewModel.activeSubscription.internalUsers}
              billingCycle={viewModel.activeSubscription.billingCycle}
              title={RESX.Subscription.CurrentSubscription}
              basePricePerMonth={viewModel.activeSubscription.basePricePerMonth}
              pricePerUserPerMonth={viewModel.activeSubscription.pricePerUserPerMonth}
              currency="eur"
              pricingAppliesFrom={moment.utc(viewModel.activeSubscription.start)}
            />
          </>}

          {/* {viewModel.nextSubscriptionType.value === "paid" && <>
            <SubscriptionPricingPanel
              discountPercentage={viewModel.discountPercentage}
              discountUntil={viewModel.discountUntil}
              billingCycle={viewModel.nextBillingCycle.value}
              internalUsers={viewModel.enabledInternalUsers}
              title={nextSubscriptionPricingTitle}
              basePricePerMonth={viewModel.agencyMonthlyPricingMay2025.basePricePerMonth}
              pricePerUserPerMonth={viewModel.agencyMonthlyPricingMay2025.pricePerUserPerMonth}
              currency="eur"
              pricingAppliesFrom={newPricingAppliesFrom}
            />
          </>} */}

        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BillingDetailsPanel {...viewModel} />

          <UserActionPanel
            userActions={viewModel.recentChanges}
            title={RESX.GeneralLabels.RecentChanges}
            displayRemoteAddress={false}
            userActionsUrl={routes.userAction_List().absolute}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>

    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}

export default SubscriptionDetailPage;